import { EdgeStack } from '@/react/edge/edge-stacks/types';

import { GitFormModel, RelativePathModel } from '../types';

export function parseRelativePathResponse(stack: EdgeStack): RelativePathModel {
  return {
    SupportRelativePath: stack.SupportRelativePath,
    AlwaysCloneGitRepoForRelativePath: stack.AlwaysCloneGitRepoForRelativePath,
    FilesystemPath: stack.FilesystemPath,
    SupportPerDeviceConfigs: stack.SupportPerDeviceConfigs,
    PerDeviceConfigsMatchType: stack.PerDeviceConfigsMatchType,
    PerDeviceConfigsGroupMatchType: stack.PerDeviceConfigsGroupMatchType,
    PerDeviceConfigsPath: stack.PerDeviceConfigsPath,
  };
}

export const dummyGitForm: GitFormModel = {
  SourceId: 0,
  AdditionalFiles: [],
  RepositoryReferenceName: '',
  ComposeFilePathInRepository: '',
};
